// Statistic Model
export class Statistic {
  constructor(data = {}) {
    const stats = data.statistics || {};

    // Core statistics values
    this.statistics = {
      reportsGenerated: stats.reportsGenerated || 0,
      transcriptionsMade: stats.transcriptionsMade || 0, // Includes live reports & voice transcriptions
      charactersGenerated: stats.charactersGenerated || 0,
      percentile: stats.percentile || 0 // Relative ranking compared to other users/enterprises
    };

    // Optional profile for derived calculations (e.g., average per day)
    this.profileCreatedAt = this._extractCreatedAt(data.profile, data.profileCreatedAt);

    // Derived values
    this._averageReportsPerDay = this._computeAverageReportsPerDay();
    this._computeTimeAndProgressDeriveds();
  }

  _extractCreatedAt(profile, profileCreatedAt) {
    try {
      if (profileCreatedAt) return new Date(profileCreatedAt);
      if (profile?.user?.createdAt) return new Date(profile.user.createdAt);
      if (profile?.createdAt) return new Date(profile.createdAt);
    } catch (_) {
      // ignore parse errors
    }
    return null;
  }

  _computeAverageReportsPerDay() {
    if (!this.profileCreatedAt || Number.isNaN(this.profileCreatedAt.getTime())) return 12;
    const now = new Date();
    const msInDay = 1000 * 60 * 60 * 24;
    let diffDays = Math.max(1, Math.floor((now - this.profileCreatedAt) / msInDay));
    diffDays = diffDays / 1.3;
    const avg = this.statistics.reportsGenerated / diffDays;
    return Math.round(avg);
  }

  _computeTimeAndProgressDeriveds() {
    const totalHours = Math.floor((this.statistics.charactersGenerated || 0) / 5000);
    const days = Math.floor(totalHours / 24);
    const months = Math.floor(days / 30);
    const remainingDays = days % 30;
    const remainingHours = totalHours % 24;

    const reportsProgress = Math.min(((this.statistics.reportsGenerated || 0) / 1000) * 100, 100);
    const targetDailyReports = 15;
    const averagePerDay = this._averageReportsPerDay || 0;
    const timeProgress = Math.min(Math.max((averagePerDay / targetDailyReports) * 100, 0), 100);

    this._totalHours = totalHours;
    this._months = months;
    this._days = days;
    this._remainingDays = remainingDays;
    this._remainingHours = remainingHours;
    this._reportsProgress = Math.round(reportsProgress);
    this._timeProgress = Math.round(timeProgress);
  }

  // Convenience getters
  get reportsGenerated() {
    return this.statistics.reportsGenerated;
  }

  get transcriptionsMade() {
    return this.statistics.transcriptionsMade;
  }

  get charactersGenerated() {
    return this.statistics.charactersGenerated;
  }

  get percentile() {
    return this.statistics.percentile;
  }

  get averageReportsPerDay() {
    return this._averageReportsPerDay;
  }

  get totalHours() {
    return this._totalHours || 0;
  }

  get months() {
    return this._months || 0;
  }

  get days() {
    return this._days || 0;
  }

  get remainingDays() {
    return this._remainingDays || 0;
  }

  get remainingHours() {
    return this._remainingHours || 0;
  }

  get reportsProgress() {
    return this._reportsProgress || 0;
  }

  get timeProgress() {
    return this._timeProgress || 0;
  }
}